<template>
  <div class="about">
    <h1>Solicitudes</h1>
    <div v-if="!logged" class="uk-margin">
      <p>Ingresa tu correo registrado como administrador y su contraseña correspondiente, luego da click en Ingresar</p>
      <input type="email" class="uk-input" v-model="mail" placeholder="Correo">
      <input type="password" class="uk-input" v-model="pass" placeholder="Contraseña">
      <a href="#" v-on:click="reset" uk-tooltip='Da click para enviar el correo de cambio de contraseña al correo registrado como administrador.'>Cambiar contraseña</a>
      <p>
        <button class="uk-button uk-button-primary uk-button-large" v-on:click="login"> Ingresar </button>
      </p>
      <p v-if="loading"><span uk-spinner="ratio:4"></span></p>
    </div>
    <div v-else>

    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>
            Fecha de registro
          </th>
          <th>
            Nombre
          </th>
          <th>
            Capacidad de pago sin buró
          </th>
          <th>
            Completar 7C
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in Object.keys(data).reverse()" >
          <td>
            {{new Date(parseInt(item)).toLocaleString()}}
          </td>
          <td>
            {{data[item].entrevista['1 - DATOS GENERALES']['Nombre Completo']}}
          </td>
          <td>
              <button v-on:click="view(item)" class="uk-button uk-button-primary uk-border-rounded" style="background-color: #6636cf">Ver</button>
          </td>
          <td>
              <button v-on:click="load(item)" class="uk-button uk-button-primary uk-border-rounded" style="background-color: #6636cf">Cargar</button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data:function () {
    return {
      loading: false,
      logged : sessionStorage.getItem('uid') ? this.autolog() : false,
      data: {},
      pass : '',
      mail : '',
    }
  },
  methods:{
    autolog : function(){

                          firebase.database().ref('apps/solicitud/integral/reportes/').once('value').then(function (s) {
                            
                            this.data = s.toJSON()
                            this.logged = true
                            this.loading = false
                          }.bind(this))
    },
    reset: async function () {
            UIkit.notification('Se ha enviado un correo con con las instrucciones a la dirección registrada')
            await firebase.auth().sendPasswordResetEmail('admin@prospec.com').then(function(){
            }.bind(this)).catch(function(error){
            if(error.code){
                UIkit.notification(error.message,'danger')
                this.loaded = true
            }
            }.bind(this))
    },
    login: async function () {
            this.loading = true
            try {
                    await firebase.auth().signInWithEmailAndPassword(this.mail,this.pass).then(async function (res) {
                      var uid = res.user.uid
                      firebase.database().ref('apps/prospecting/integral/admin/' + uid).once('value').then(function (s) {
                        if(!s.exists()){
                          UIkit.notification('Ususario no registrado como administrador','danger')
                            this.loading = false
                          return
                        } else {
                          firebase.database().ref('apps/solicitud/integral/reportes/').once('value').then(function (s) {
                            
                            this.data = s.toJSON()
                            sessionStorage.setItem('uid', uid)
                            this.logged = true
                            this.loading = false
                          }.bind(this))
                        }
                      }.bind(this))
                    }.bind(this))

              
            } catch (e) {
                UIkit.notification(e.message, 'danger')
                this.loading = false
            }
    },
    load:function (id) {
        
        this.$score = this.data[id].seven
        
        UIkit.notification('Se cargaron todos los campos compatibles','success')
        sessionStorage.setItem('score',JSON.stringify(this.$score))
        sessionStorage.setItem('loaded', 1)
        this.$router.push('1c')
    }, 
    view:function(id){
        this.$score = this.data[id].seven
        
        UIkit.notification('Se cargaró el score','success')
        sessionStorage.setItem('score',JSON.stringify(this.$score))
        sessionStorage.setItem('view', 1)
        this.$router.push('precal')

    },



          
  },
  mounted:function() {
  },
}
</script>
